// This component has been autogenerated with 'generate:components' script

import { cx } from 'classix'
import styles from 'icons/Icon.module.css'
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'

export const IconInfoL = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: The <title> tag error is false positive error
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 12 12'
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='info-l'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path d='M6 3.667a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.333 1h-.666v4.666h.666z' />
			<path fill='none' d='M0 0h12v12H0z' />
			<path
				fill='none'
				stroke='currentColor'
				strokeWidth='1.5'
				d='M0 0h12v12H0z'
			/>
		</svg>
	)
}
